import { IEntity, Entity } from "./Entity";
import { IRiskType } from "./RiskType";

export interface IRiskRiskType extends IEntity {
    RiskID: number | null;
    RiskTypeID: number | null;
    RiskType?: IRiskType;
}

export class RiskRiskType extends Entity implements IRiskRiskType {
    public RiskID = null;
    public RiskTypeID = null;

}